export default __webpack_public_path__ + "static/media/task-yellow.05f289f0.svg";